module.exports = __webpack_public_path__ + "static/media/pago_exitoso_n_pedido.0378783a.png";